import { UserProfile } from '../profile';

export default function ProfileScreen({ onBack }) {
  return <UserProfile onClose={onBack} />;
}
